module.exports = __webpack_public_path__ + "img/sections.902975d3.svg";